export const setConfig = () => {
	const initConfig = {};

	// set default colors
	initConfig.COLORS = {
		Primary: '',
	};

	if (process.env.NODE_ENV === 'production' && window.kioskFRCASettings) {
		Object.keys(window.kioskFRCASettings).forEach(setting => {
			initConfig[setting] = window.kioskFRCASettings[setting];
		});

		window.kioskFRCASettings.VERSION = '0.3.0';
	} else {
		initConfig.ESTORIS_BASE_PATH = __FR_CREDIT_APP_API__; 
		initConfig.TIMEOUT = __TIMEOUT__; 
		initConfig.COLORS = __COLORS__;

		// dev
		// initConfig.ESTORIS_BASE_PATH = "https://172.18.10.88:44369";
		// initConfig.TIMEOUT = 30000; 
		// initConfig.COLORS = '{"Primary": "#270cf0"}';
	}

	initConfig.ESTORIS_BASE_PATH = `${initConfig.ESTORIS_BASE_PATH}/apply`;
	initConfig.TIMEOUT = JSON.parse(initConfig.TIMEOUT);
	initConfig.COLORS = JSON.parse(initConfig.COLORS);

	return initConfig;
};

const config = setConfig();

export default config;
